import React, { useEffect } from "react";
import { TERMS_OF_USE_URL } from "@/helpers/legalLinks";

const TermsOfService = () => {
  useEffect(() => {
    window.location.replace(TERMS_OF_USE_URL);
  }, []);

  return (
    <p className="text-center p-5">
      Opening the <a href={TERMS_OF_USE_URL}>Terms of Use</a>…
    </p>
  );
};

export default TermsOfService;
